export const proposalStatuses = {
  inProgress: 'IN_PROGRESS',
  notApplicable: 'NOT_APPLICABLE',
};
